import {
  inferAppsCodeFromAccessList,
  resolveAccessControlPageKeys,
} from "./pageNames";

/**
 * @param {string} pageName
 * @param {string} requiredAccess
 * @param {Array<{ pageName?: string, accessType?: string }>} accessControlList
 * @param {string | null | undefined} [appsCode] authenticated tenant appsCode when available
 */
export const hasAccess = (
  pageName,
  requiredAccess,
  accessControlList,
  appsCode = null,
) => {
  if (!pageName || !requiredAccess || !Array.isArray(accessControlList)) {
    return false;
  }

  const resolvedAppsCode =
    appsCode?.trim() || inferAppsCodeFromAccessList(accessControlList);
  const matchKeys = new Set(
    resolveAccessControlPageKeys(pageName, resolvedAppsCode).map((k) =>
      k.trim(),
    ),
  );

  const accessTypes = accessControlList
    .filter((entry) => matchKeys.has(entry.pageName?.trim()))
    .map((entry) => entry.accessType.toLowerCase());

  if (requiredAccess.toLowerCase() === "read/write") {
    return accessTypes.includes("read/write");
  }

  if (requiredAccess.toLowerCase() === "read") {
    return accessTypes.includes("read") || accessTypes.includes("read/write");
  }

  return false;
};

/**
 * @param {string} pageName
 * @param {string} requiredAccess
 * @param {{ appsCode?: string, accessControlList?: Array<{ pageName?: string, accessType?: string }> } | null | undefined} user
 */
export const hasAccessForUser = (pageName, requiredAccess, user) => {
  if (!user) {
    return false;
  }
  return hasAccess(
    pageName,
    requiredAccess,
    user.accessControlList,
    user.appsCode,
  );
};
